import React from "react";
import { useSelector } from "react-redux";

import { Grid, Typography } from "@mui/material";
import { IEmailConversationActivity } from "../../redux/activity/activity.types";
import { Dialog } from "../Dialogs/Dialog";
import { CustomFormLabel, CustomTextField } from "../formsComponents";
import { IFileUpload } from "../FileUpload/FileUpload.type";
import { getUniqueId } from "../../helpers";
import { FileUpload } from "../FileUpload/components/FileUpload";

export interface IAcitivtyEmailConversationDialogProps {
  open: boolean;
  data: IEmailConversationActivity;
  onClose: () => void;
}

export const AcitivtyEmailConversationDialog: React.FC<
  IAcitivtyEmailConversationDialogProps
> = (props) => {
  const { open, data, onClose } = props;

  const [attachmentsList, setAttachmentsList] = React.useState<IFileUpload[]>(
    (data.attachments || []).map((x: any) => ({
      file: null,
      key: getUniqueId(),
      path: x,
    }))
  );

  return (
    <Dialog
      open={open}
      title="Email Conersation"
      onClose={onClose}
      size="sm"
      actions={[
        {
          type: "button",
          label: "Close",
          variant: "contained",
          onClick: onClose,
        },
      ]}
    >
      <Grid container spacing={1}>
        <Grid item xs={12} lg={12}>
          <CustomFormLabel>Emails</CustomFormLabel>
          <CustomTextField
            fullWidth
            value={(data.to_mail_ids || []).join(",")}
          />
        </Grid>
        <Grid item xs={12} lg={12}>
          <CustomFormLabel>CC</CustomFormLabel>
          <CustomTextField
            fullWidth
            value={(data.cc_mail_ids || []).join(",")}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <CustomFormLabel>Body</CustomFormLabel>
          <Typography variant="body1">
            <span
              dangerouslySetInnerHTML={{ __html: data.body.content || "" }}
            ></span>
          </Typography>
        </Grid>

        <Grid item xs={12}>
          {attachmentsList.length > 0 && (
            <>
              <CustomFormLabel>Attachments</CustomFormLabel>
              <FileUpload
                multiple
                value={attachmentsList}
                disabled
                deleteDisabled
              />
            </>
          )}
        </Grid>
      </Grid>
    </Dialog>
  );
};
